import { SupportedDashboardComponent } from "@aidkitorg/types/lib/admin-panel/dashboard";
import { useDashboards } from "../../../Contexts/DashboardsContext";

export const useUpdateComponentById = () => {
  const { setStagedComponents } = useDashboards();

  const updateComponentById = (id: string, updatedComponent: SupportedDashboardComponent) => {
    setStagedComponents((prevComponents) =>
      prevComponents.map((component) =>
        component.id === id
          ? {
            ...component,
            config: JSON.parse(JSON.stringify(updatedComponent)), // full replacement
          }
          : component
      )
    );
  };

  return updateComponentById;
};
